import React, { useEffect } from 'react';
import { Alert, Fade, Box } from '@mui/material';

const AlertMessage = ({ message, type = 'error', onClose, duration = 5000 }) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        minWidth: 300,
        maxWidth: '90%',
      }}
    >
      <Fade in={!!message}>
        <Alert
          severity={type}
          sx={{
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            backdropFilter: 'blur(10px)',
            backgroundColor: type === 'error' ? 'rgba(211, 47, 47, 0.95)' : 'rgba(46, 125, 50, 0.95)',
            color: 'white',
            '& .MuiAlert-icon': {
              color: 'white',
            },
            animation: 'slideIn 0.3s ease-out',
            '@keyframes slideIn': {
              from: {
                transform: 'translateY(-100%)',
                opacity: 0,
              },
              to: {
                transform: 'translateY(0)',
                opacity: 1,
              },
            },
          }}
        >
          {message}
        </Alert>
      </Fade>
    </Box>
  );
};

export default AlertMessage;
